// AUTO-GENERATED by tools/design-tokens/generate-css-refs.ts -- do not edit.
// Regenerate: npm run generate:derived-artifacts (or any typecheck/vitest run -- both ensure it)

/** Complete layout token bundle */
export const layoutTokens = {
	modal: {
		sm: {
			width: "var(--layout-modal-sm-width)",
			maxHeight: "var(--layout-modal-sm-max-height)",
		},
		md: {
			width: "var(--layout-modal-md-width)",
			maxHeight: "var(--layout-modal-md-max-height)",
		},
		lg: {
			width: "var(--layout-modal-lg-width)",
			maxHeight: "var(--layout-modal-lg-max-height)",
		},
		xl: {
			width: "var(--layout-modal-xl-width)",
			maxHeight: "var(--layout-modal-xl-max-height)",
		},
		full: {
			width: "var(--layout-modal-full-width)",
			height: "var(--layout-modal-full-height)",
		},
		padding: {
			sm: "var(--layout-modal-padding-sm)",
			md: "var(--layout-modal-padding-md)",
			lg: "var(--layout-modal-padding-lg)",
		},
		backdrop: {
			background: "var(--layout-modal-backdrop-background)",
			blur: "var(--layout-modal-backdrop-blur)",
		},
	},
	drawer: {
		narrow: "var(--layout-drawer-narrow)",
		"default": "var(--layout-drawer-default)",
		wide: "var(--layout-drawer-wide)",
		full: "var(--layout-drawer-full)",
		mobile: "var(--layout-drawer-mobile)",
	},
	sidebar: {
		collapsed: "var(--layout-sidebar-collapsed)",
		"default": "var(--layout-sidebar-default)",
		wide: "var(--layout-sidebar-wide)",
		itemHeight: "var(--layout-sidebar-item-height)",
	},
	header: {
		mobile: "var(--layout-header-mobile)",
		desktop: "var(--layout-header-desktop)",
		compact: "var(--layout-header-compact)",
		tall: "var(--layout-header-tall)",
		logo: {
			mobile: "var(--layout-header-logo-mobile)",
			desktop: "var(--layout-header-logo-desktop)",
		},
	},
	mobileNav: {
		height: "var(--layout-mobile-nav-height)",
		heightRem: "var(--layout-mobile-nav-height-rem)",
	},
	footer: {
		compact: "var(--layout-footer-compact)",
		"default": "var(--layout-footer-default)",
		expanded: "var(--layout-footer-expanded)",
	},
	contentMaxWidth: {
		panel: "var(--layout-content-max-width-panel)",
		prose: "var(--layout-content-max-width-prose)",
		narrow: "var(--layout-content-max-width-narrow)",
		"default": "var(--layout-content-max-width-default)",
		wide: "var(--layout-content-max-width-wide)",
		extraWide: "var(--layout-content-max-width-extra-wide)",
		full: "var(--layout-content-max-width-full)",
	},
	proportion: {
		bubble: "var(--layout-proportion-bubble)",
		floating: "var(--layout-proportion-floating)",
		floatingInset: "var(--layout-proportion-floating-inset)",
		truncated: "var(--layout-proportion-truncated)",
		belowAnchor: "var(--layout-proportion-below-anchor)",
	},
	card: {
		minHeight: "var(--layout-card-min-height)",
		maxWidth: "var(--layout-card-max-width)",
		property: {
			width: "var(--layout-card-property-width)",
			aspectRatio: "var(--layout-card-property-aspect-ratio)",
			imageHeight: "var(--layout-card-property-image-height)",
		},
		compact: {
			minHeight: "var(--layout-card-compact-min-height)",
			padding: "var(--layout-card-compact-padding)",
		},
		standard: {
			minHeight: "var(--layout-card-standard-min-height)",
			padding: "var(--layout-card-standard-padding)",
		},
		large: {
			minHeight: "var(--layout-card-large-min-height)",
			padding: "var(--layout-card-large-padding)",
		},
	},
	list: {
		itemHeight: {
			compact: "var(--layout-list-item-height-compact)",
			"default": "var(--layout-list-item-height-default)",
			comfortable: "var(--layout-list-item-height-comfortable)",
		},
		container: {
			maxHeight: "var(--layout-list-container-max-height)",
			scrollableHeight: "var(--layout-list-container-scrollable-height)",
		},
		itemPadding: {
			compact: "var(--layout-list-item-padding-compact)",
			"default": "var(--layout-list-item-padding-default)",
			comfortable: "var(--layout-list-item-padding-comfortable)",
		},
		dropdown: {
			maxHeight: "var(--layout-list-dropdown-max-height)",
		},
	},
	table: {
		rowHeight: {
			dense: "var(--layout-table-row-height-dense)",
			"default": "var(--layout-table-row-height-default)",
			comfortable: "var(--layout-table-row-height-comfortable)",
		},
		headerHeight: {
			"default": "var(--layout-table-header-height-default)",
		},
		cellPadding: {
			dense: "var(--layout-table-cell-padding-dense)",
			"default": "var(--layout-table-cell-padding-default)",
			comfortable: "var(--layout-table-cell-padding-comfortable)",
		},
		stickyOffset: "var(--layout-table-sticky-offset)",
	},
	grid: {
		columns: "var(--layout-grid-columns)",
		gutter: {
			mobile: "var(--layout-grid-gutter-mobile)",
			tablet: "var(--layout-grid-gutter-tablet)",
			desktop: "var(--layout-grid-gutter-desktop)",
		},
		container: {
			mobile: "var(--layout-grid-container-mobile)",
			tablet: "var(--layout-grid-container-tablet)",
		},
		spans: {
			full: "var(--layout-grid-spans-full)",
			half: "var(--layout-grid-spans-half)",
			third: "var(--layout-grid-spans-third)",
			quarter: "var(--layout-grid-spans-quarter)",
			twoThirds: "var(--layout-grid-spans-two-thirds)",
			threeQuarters: "var(--layout-grid-spans-three-quarters)",
		},
	},
	safeAreas: {
		mobileNotch: "var(--layout-safe-areas-mobile-notch)",
		bottomBar: "var(--layout-safe-areas-bottom-bar)",
		androidNav: "var(--layout-safe-areas-android-nav)",
		env: {
			top: "var(--layout-safe-areas-env-top)",
			right: "var(--layout-safe-areas-env-right)",
			bottom: "var(--layout-safe-areas-env-bottom)",
			left: "var(--layout-safe-areas-env-left)",
		},
		max: {
			top: "var(--layout-safe-areas-max-top)",
			right: "var(--layout-safe-areas-max-right)",
			bottom: "var(--layout-safe-areas-max-bottom)",
			left: "var(--layout-safe-areas-max-left)",
		},
	},
	touchTargets: {
		minimum: "var(--layout-touch-targets-minimum)",
		recommended: "var(--layout-touch-targets-recommended)",
		comfortable: "var(--layout-touch-targets-comfortable)",
		large: "var(--layout-touch-targets-large)",
	},
	pointerTargets: {
		minimum: "var(--layout-pointer-targets-minimum)",
	},
	focus: {
		ring: {
			"default": {
				width: "var(--layout-focus-ring-default-width)",
				color: "var(--layout-focus-ring-default-color)",
			},
			error: {
				width: "var(--layout-focus-ring-error-width)",
				color: "var(--layout-focus-ring-error-color)",
			},
		},
		visible: {
			outline: "var(--layout-focus-visible-outline)",
			outlineOffset: "var(--layout-focus-visible-outline-offset)",
		},
	},
	divider: {
		thickness: {
			thin: "var(--layout-divider-thickness-thin)",
			medium: "var(--layout-divider-thickness-medium)",
			thick: "var(--layout-divider-thickness-thick)",
		},
		spacing: {
			small: "var(--layout-divider-spacing-small)",
			medium: "var(--layout-divider-spacing-medium)",
			large: "var(--layout-divider-spacing-large)",
		},
	},
	scroll: {
		offset: "var(--layout-scroll-offset)",
		scrollbar: {
			width: "var(--layout-scroll-scrollbar-width)",
			thin: "var(--layout-scroll-scrollbar-thin)",
		},
		virtualBuffer: "var(--layout-scroll-virtual-buffer)",
	},
	viewport: {
		fullHeight: "var(--layout-viewport-full-height)",
		minHeight: "var(--layout-viewport-min-height)",
		fullWidth: "var(--layout-viewport-full-width)",
		half: "var(--layout-viewport-half)",
		third: "var(--layout-viewport-third)",
		quarter: "var(--layout-viewport-quarter)",
		threeQuarters: "var(--layout-viewport-three-quarters)",
		nearFull: "var(--layout-viewport-near-full)",
		contentMax: "var(--layout-viewport-content-max)",
		dialogContent: "var(--layout-viewport-dialog-content)",
		panelContent: "var(--layout-viewport-panel-content)",
		twoThirdsHeight: "var(--layout-viewport-two-thirds-height)",
		mobilePanel: "var(--layout-viewport-mobile-panel)",
		compactPanel: "var(--layout-viewport-compact-panel)",
		widthNearFull: "var(--layout-viewport-width-near-full)",
		widthLarge: "var(--layout-viewport-width-large)",
		widthMedium: "var(--layout-viewport-width-medium)",
	},
} as const;
